import { onMounted, onUnmounted, ref } from 'vue'
import {
  LEARN_PROGRESS_CHANGED_EVENT,
  isLessonComplete,
  loadCompletedLessonIds,
  markLessonComplete,
  markLessonIncomplete,
} from '@/lib/learnProgress'
import { totalLessonCount } from '@/data/learn/curriculum'

export function useLearnProgress() {
  const completedIds = ref<Set<string>>(loadCompletedLessonIds())

  const refresh = () => {
    completedIds.value = loadCompletedLessonIds()
  }

  onMounted(() => window.addEventListener(LEARN_PROGRESS_CHANGED_EVENT, refresh))
  onUnmounted(() => window.removeEventListener(LEARN_PROGRESS_CHANGED_EVENT, refresh))

  const toggleComplete = (lessonId: string) => {
    if (isLessonComplete(lessonId)) markLessonIncomplete(lessonId)
    else markLessonComplete(lessonId)
    refresh()
  }

  const completedCount = () => completedIds.value.size
  const progressPercent = () =>
    totalLessonCount === 0 ? 0 : Math.round((completedIds.value.size / totalLessonCount) * 100)

  return { completedIds, toggleComplete, completedCount, progressPercent, totalLessonCount }
}
